module.exports = __webpack_public_path__ + "static/media/tp8.9761cad3.jpg";